import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h3", { class: "text-lg font-bold text-textPrimary" }, "Critérios da aprovação automática", -1)
const _hoisted_2 = {
  class: "text-left text-sm text-textPrimary",
  "data-testid": "auto-approval-criteria-modal"
}
const _hoisted_3 = {
  class: "mb-3 text-neutral50",
  "data-testid": "auto-approval-criteria-intro"
}
const _hoisted_4 = {
  key: 0,
  class: "flex flex-col gap-2"
}
const _hoisted_5 = ["data-testid"]
const _hoisted_6 = {
  key: 0,
  class: "block text-xs text-neutral50"
}
const _hoisted_7 = {
  class: "flex flex-col gap-2",
  "data-testid": "auto-approval-criteria-fallback"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", {
  class: "mt-0.5 text-xs font-bold text-neutral50",
  "aria-hidden": "true"
}, "•", -1)
const _hoisted_9 = { class: "mt-3 text-xs text-neutral50" }
const _hoisted_10 = { class: "flex justify-end" }

import { computed } from 'vue'
import Modal from '@/components/designSystem/modals/Modal.vue'
import OutlineButton from '@/components/designSystem/Buttons/OutlineButton/index.vue'
import {
  AUTO_APPROVAL_CRITERIA_FALLBACK,
  AUTO_APPROVAL_CRITERIA_FALLBACK_NOTE
} from '@/constants/ds-attendance-auto-approval.constants'
import type { DSAttendanceAutoApprovalCriterion } from '@/Network/Types/Responses/DsAttendanceAuditResponses'


export default /*#__PURE__*/_defineComponent({
  __name: 'DsAttendanceAutoApprovalCriteriaModal',
  props: {
    modelValue: { type: Boolean },
    criteria: { default: () => [] }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit }) {

const props = __props;

/**
 * Fase 2 do fluxo de auditoria (spec 2026-09-11 §6.3/§6.4) — "Ver critérios" do banner de
 * aprovação automática. Mostra o vetor avaliado pelo motor quando a trilha o devolve; sem
 * ele, os seis critérios da política como texto estático.
 */




/**
 * O vetor da trilha pode trazer um critério com `passed: false` (registro aprovado por uma
 * política anterior, critério que deixou de valer). Afirmar "todos os critérios passaram" com
 * um ✕ na lista logo abaixo contradiz o que o auditor está vendo.
 */
const allCriteriaPassed = computed(() =>
  props.criteria.every((criterion) => criterion.passed !== false)
)

const introText = computed(() =>
  allCriteriaPassed.value
    ? 'O registro foi aprovado sem passar pela auditoria porque todos os critérios abaixo passaram.'
    : 'O registro foi aprovado sem passar pela auditoria. Veja abaixo os critérios avaliados.'
)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Modal, {
    "modal-active": _ctx.modelValue,
    "has-header-border": "",
    "has-footer-border": "",
    "max-width": "max-w-[560px]",
    onClose: _cache[1] || (_cache[1] = ($event: any) => (emit('update:modelValue', false)))
  }, {
    header: _withCtx(() => [
      _hoisted_1
    ]),
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_10, [
        _createVNode(OutlineButton, {
          text: "Fechar",
          width: "120px",
          height: "40px",
          "data-testid": "auto-approval-criteria-close",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('update:modelValue', false)))
        })
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("p", _hoisted_3, _toDisplayString(introText.value), 1),
        (_ctx.criteria.length > 0)
          ? (_openBlock(), _createElementBlock("ul", _hoisted_4, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.criteria, (criterion, index) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: criterion.key || index,
                  class: "flex items-start gap-2",
                  "data-testid": `auto-approval-criterion-${index}`
                }, [
                  _createElementVNode("span", {
                    class: _normalizeClass(["mt-0.5 text-xs font-bold", criterion.passed === false ? 'text-negative' : 'text-sucess']),
                    "aria-hidden": "true"
                  }, _toDisplayString(criterion.passed === false ? '✕' : '✓'), 3),
                  _createElementVNode("span", null, [
                    _createTextVNode(_toDisplayString(criterion.label || criterion.key) + " ", 1),
                    (criterion.detail)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(criterion.detail), 1))
                      : _createCommentVNode("", true)
                  ])
                ], 8, _hoisted_5))
              }), 128))
            ]))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createElementVNode("ul", _hoisted_7, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(AUTO_APPROVAL_CRITERIA_FALLBACK), (text, index) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: index,
                    class: "flex items-start gap-2"
                  }, [
                    _hoisted_8,
                    _createElementVNode("span", null, _toDisplayString(text), 1)
                  ]))
                }), 128))
              ]),
              _createElementVNode("p", _hoisted_9, _toDisplayString(_unref(AUTO_APPROVAL_CRITERIA_FALLBACK_NOTE)), 1)
            ], 64))
      ])
    ]),
    _: 1
  }, 8, ["modal-active"]))
}
}

})